namespace TotalPoll {
    import Service = TotalCore.Common.Service;
    import ColorsService = TotalCore.Common.Providers.ColorsService;
    import EXTRACT_TYPE = TotalCore.Common.EXTRACT_TYPE;
    import extract = TotalCore.Common.extract;

    @Service('services.totalpoll')
    export class RepositoryService {
        private resource;

        constructor($resource, private $httpParamSerializerJQLike, private prefix, private ajaxEndpoint, private pollId, private ColorsService: ColorsService) {
            this.resource = $resource(ajaxEndpoint, {}, {
                metrics: {method: 'GET', cache: true, params: {poll: pollId}, isArray: false},
                polls: {method: 'GET', cache: true, isArray: true},
            });
        }

        getMetrics(filters = {}) {
            return this.resource
                .metrics(angular.extend({}, {action: 'totalpoll_insights_metrics'}, filters))
                .$promise
                .then((response) => {
                    let metrics: any = {choice: {}, day: {}, month: {}, year: {}, os: {}, browser: {}};

                    // Choices
                    angular.forEach(response.choices, (item) => {
                        metrics.choice[item.choice_uid] = Number(item.votes);
                    });

                    angular.forEach(response.period, (item) => {
                        let date = item.period.split('-');
                        let year = date[0];
                        let month = date[1];

                        metrics.day[item.period] = Number(item.votes);
                        metrics.month[`${year}-${month}`] = (metrics.month[`${year}-${month}`] || 0) + Number(item.votes) || 0;
                        metrics.year[year] = (metrics.year[year] || 0) + Number(item.votes);
                    });

                    angular.forEach(response.platforms, (item) => {
                        metrics.browser[item.browser] = (metrics.browser[item.browser] || 0) + Number(item.votes);
                        metrics.os[item.os] = (metrics.os[item.os] || 0) + Number(item.votes);
                    });

                    angular.forEach(metrics, (value, key) => {
                        let color = this.ColorsService.getRandomColors(1)[0];

                        metrics[key] = {
                            labels: extract(metrics[key], EXTRACT_TYPE.Keys),
                            datasets: [{
                                label: 'Votes',
                                data: extract(metrics[key], EXTRACT_TYPE.Values),
                                backgroundColor: color,
                                borderColor: color,
                                fill: false
                            }]
                        };

                        if (key === 'browser' || key === 'os' || key === 'choice') {
                            metrics[key].datasets[0].backgroundColor = this.ColorsService.getRandomColors(metrics[key].labels.length);
                            delete metrics[key].datasets[0].borderColor;
                        }

                    });

                    return metrics;
                });
        }

        getPolls() {
            return this.resource.polls({action: 'totalpoll_insights_polls'}).$promise
        }

        getDownload(format, filters = {}) {
            let iframe = document.createElement('iframe');
            let query = this.$httpParamSerializerJQLike(angular.extend({}, {
                action: `${this.prefix}_insights_download`,
                poll: this.pollId,
                format: format
            }, filters));
            iframe.src = `${this.ajaxEndpoint}?${query}`;
            iframe.width = '0';
            iframe.height = '0';
            document.body.appendChild(iframe);
        }
    }
}
